import { type BlokProps, StoryblokStory } from "@trydig/storyblok";
import type { StoriesRoute } from "@/data/routes/stories.route";
import type { ReusableBlokStoryblok } from "@/generated/sb/sb-types";

export const ReusableBlok = ({
  data,
  preview,
  ...rest
}: BlokProps<ReusableBlokStoryblok, StoriesRoute["reusable"]>) => {
  return data?.map((blok) => (
    <StoryblokStory {...rest} story={blok} key={blok.uuid} preview={preview} />
  ));
};
